'use strict';

import { Entity } from '../Entity';
import { Ind } from '../Ind/Ind';

export const ACTION_TYPES = {
  APPOINTMENT: 'appointment',
  ALERT: 'alert',
  ACTIVITY: 'activity',
  DISMISS: 'dismiss',
} as const;

export type ActionType = (typeof ACTION_TYPES)[keyof typeof ACTION_TYPES];

export const STATUS_TYPES = {
  PENDING: 'pending',
  CONVERTED: 'converted',
  DISMISSED: 'dismissed',
} as const;

export type StatusType = (typeof STATUS_TYPES)[keyof typeof STATUS_TYPES];

export class UserActionSuggestion extends Entity {
  protected id;

  protected user;

  protected ind;

  protected callLog;

  protected callLogSummary;

  protected reference;

  protected referenceType;

  protected label;

  protected suggestion;

  protected status;

  protected targetType;

  protected targetId;

  protected dateTimeCreated;

  protected dateTimeResolved;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;

    this.user = data.user;

    this.callLog = data.callLog;

    this.callLogSummary = data.callLogSummary;

    this.reference = data.reference;

    this.referenceType = data.referenceType;

    this.label = data.label;

    this.suggestion = data.suggestion;

    this.status = data.status;

    this.targetType = data.targetType;

    this.targetId = data.targetId;

    this.dateTimeResolved = data.dateTimeResolved;

    if (data.dateTimeCreated) {
      const dateTimeCreated = data.dateTimeCreated.date.split(' ')[0].split('-');
      this.dateTimeCreated =
        dateTimeCreated[1] + '/' + dateTimeCreated[2] + '/' + dateTimeCreated[0];
    }

    if (data.ind) {
      const ind = new Ind();

      ind.hydrate(data.ind);

      this.ind = ind;
    }
  }

  public getId() {
    return this.id;
  }

  public setId(id) {
    this.id = id;

    return this;
  }

  public getUser() {
    return this.user;
  }

  public setUser(user) {
    this.user = user;

    return this;
  }

  public getInd() {
    return this.ind;
  }

  public setInd(ind) {
    this.ind = ind;

    return this;
  }

  public getCallLog() {
    return this.callLog;
  }

  public setCallLog(callLog) {
    this.callLog = callLog;

    return this;
  }

  public getCallLogSummary() {
    return this.callLogSummary;
  }

  public setCallLogSummary(callLogSummary) {
    this.callLogSummary = callLogSummary;

    return this;
  }

  public getReference() {
    return this.reference;
  }

  public setReference(reference) {
    this.reference = reference;

    return this;
  }

  public getReferenceType() {
    return this.referenceType;
  }

  public setReferenceType(referenceType) {
    this.referenceType = referenceType;

    return this;
  }

  public getLabel() {
    return this.label;
  }

  public setLabel(label) {
    this.label = label;

    return this;
  }

  public getSuggestion() {
    return this.suggestion;
  }

  public setSuggestion(suggestion) {
    this.suggestion = suggestion;

    return this;
  }

  public getStatus() {
    return this.status;
  }

  public setStatus(status) {
    this.status = status;

    return this;
  }

  public getTargetType() {
    return this.targetType;
  }

  public setTargetType(targetType) {
    this.targetType = targetType;

    return this;
  }

  public getTargetId() {
    return this.targetId;
  }

  public setTargetId(targetId) {
    this.targetId = targetId;

    return this;
  }

  public getDateTimeCreated() {
    return this.dateTimeCreated;
  }

  public setDateTimeCreated(dateTimeCreated) {
    this.dateTimeCreated = dateTimeCreated;

    return this;
  }

  public getDateTimeResolved() {
    return this.dateTimeResolved;
  }

  public setDateTimeResolved(dateTimeResolved) {
    this.dateTimeResolved = dateTimeResolved;

    return this;
  }
}
